import React, { useEffect, useState } from "react";
import SideBar from "../navigation/sidebar/SideBar";
import NavBar from "../navigation/topnav/NavBar";
import RowTitles from "../components/RowTitles";
import { Table, Modal, Button } from "react-bootstrap";
import { SlRefresh } from "react-icons/sl";
import axios from "axios";
import { HiDotsHorizontal } from "react-icons/hi";
import Loader from "../gif/loader.gif";
import { TbRuler3 } from "react-icons/tb";

function Events() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [show, setShow] = useState(false);

  const reloadEvents = () => {
    getEvents();
  };

  const handleClose = () => setShow(false);
  const handleShow = (row) => {
    setSelectedRow(row);
    setShow(true);
  };

  const getEvents = async () => {
    setLoading(TbRuler3);
    try {
      const res = await axios.get(
        `https://ntcapi-a4fdbbdfb3gactbd.southafricanorth-01.azurewebsites.net/api/get-allevents`
      );
      let retcode = res.data;
      //delare empty array
      setEvents(retcode);
      //stop loading
      setLoading(false);
    } catch (error) {
      //stop loading
      setLoading(false);
      console.log("get all events =>" + error);
    }
  };
  useEffect(() => {
    getEvents();
  }, []);
  return (
    <div className="d-flex" style={{ backgroundColor: "#f1f5f7" }}>
      <SideBar />
      {/* Main Content */}
      <div className="flex-grow-1">
        {/* Header */}
        <NavBar />
        <div className="container-fluid mt-4">
          <div className="row">
            <div className="col-md-4 p-3">
              <RowTitles title={"Dashboad"} child={"events"} />
            </div>
            <div className="col-md-8 p-3 text-end">
              <button className="border-0" onClick={reloadEvents}>
                <SlRefresh size={30} />
              </button>
            </div>
          </div>

          <div className="container-fluid mt-4">
            {loading ? (
              <img src={Loader} alt="QR Code" width={"50"} height={"50"} />
            ) : (
              <Table striped bordered hover className="shadow">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Title</th>
                    <th>date</th>
                    <th>expriy</th>
                    <th>status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {events.map((row, index) => (
                    <tr key={index}>
                      <td>
                        <small>{row.id}</small>
                      </td>
                      <td>
                        <small>{row.title}</small>
                      </td>
                      <td>
                        <small>{row.date}</small>
                      </td>
                      <td>
                        <small>{row.expiry}</small>
                      </td>
                      <td>
                        <small>
                          {new Date().setHours(0, 0, 0, 0) <
                          new Date(row.date).setHours(0, 0, 0, 0) ? (
                            <small className="badge bg-success">upcoming</small>
                          ) : new Date().setHours(0, 0, 0, 0) >=
                              new Date(row.date).setHours(0, 0, 0, 0) ||
                            new Date().setHours(0, 0, 0, 0) <=
                              new Date(row.expiry).setHours(0, 0, 0, 0) ? (
                            <small className="badge bg-info">in prigress</small>
                          ) : (
                            <small className="badge bg-danger">
                              event passed
                            </small>
                          )}
                        </small>
                      </td>
                      <td>
                        <Button
                          className="bg-body text-black border-0"
                          onClick={() => handleShow(row)}
                        >
                          <HiDotsHorizontal />
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}
          </div>
        </div>

        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Action Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {selectedRow ? (
              <div>
                <p>
                  <b>ID:</b> {selectedRow.id}
                </p>
                <p>
                  <strong>Purchase ID:</strong> {selectedRow.purchaseId}
                </p>
                <p>
                  <strong>Title:</strong> {selectedRow.title}
                </p>
                <p>
                  <strong>User:</strong> {selectedRow.user}
                </p>
                <p>
                  <strong>Assigned To:</strong> {selectedRow.assignedTo}
                </p>
                <p>
                  <strong>Create By:</strong> {selectedRow.createBy}
                </p>
                <p>
                  <strong>Create Date:</strong> {selectedRow.createDate}
                </p>
                <p>
                  <strong>Status:</strong> {selectedRow.status}
                </p>
              </div>
            ) : (
              <p>No data available.</p>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  );
}
export default Events;
